/**
 * „Der Rekorder nimmt wirklich auf“ (19.10.2026) — das Zeichen für den Bereit-Ton.
 *
 * Geht das Mikro von selbst auf (nach einer Frage/Antwort), soll Martin hören, WANN er sprechen kann. Ein Ton beim
 * Aufruf des Starts kam zu früh: das Mikro lieferte noch nichts (Bluetooth), und die ersten Worte fehlten trotzdem.
 * Der Rekorder (ptt.ts `neuerRekorder`) meldet sein `start`-Ereignis erst, wenn er Ton annimmt — hier steht, WANN das war.
 *
 * Ein eigenes kleines Modul, damit ptt-modal.ts (der Ton) nicht ptt.ts (der Rekorder) einbinden muss.
 */

let seit = 0;
let wartende: Array<() => void> = [];

/** Eine neue Aufnahme beginnt: das Zeichen der vorigen gilt nicht mehr. */
export function recBereitZuruecksetzen(): void {
  seit = 0;
}

/** Der Rekorder nimmt auf (Ereignis `start`). */
export function meldeRecBereit(): void {
  if (seit === 0) seit = performance.now();
  const w = wartende;
  wartende = [];
  for (const f of w) f();
}

/**
 * Ruft `bereit(nachMs)` genau einmal, sobald der Rekorder aufnimmt (sofort, wenn er es schon tut; `nachMs` = so lange her
 * bzw. so lange gewartet). Kommt das Zeichen nicht innerhalb von `hoechstensMs`, ruft sie `keins()` — der Ton bleibt dann
 * aus, denn ein Ton ohne aufnehmendes Mikro verspricht etwas Falsches. Gibt eine Funktion zurück, die das Warten beendet.
 */
export function wennRecBereit(hoechstensMs: number, bereit: (nachMs: number) => void, keins: () => void): () => void {
  if (seit > 0) {
    bereit(Math.round(performance.now() - seit));
    return () => undefined;
  }
  const t0 = performance.now();
  let fertig = false;
  const timer = setTimeout(() => {
    if (fertig) return;
    fertig = true;
    wartende = wartende.filter((f) => f !== los);
    keins();
  }, hoechstensMs);
  const los = (): void => {
    if (fertig) return;
    fertig = true;
    clearTimeout(timer);
    bereit(Math.round(performance.now() - t0));
  };
  wartende.push(los);
  return () => {
    if (fertig) return;
    fertig = true;
    clearTimeout(timer);
    wartende = wartende.filter((f) => f !== los);
  };
}
